import styled from 'styled-components'
import { SelectUnstyled } from './unstyled'
import { theme } from './../../../Assets/Styles/theme'

export const Select = styled(SelectUnstyled)`
  position: relative;
  height: 40px;

  .select-field {
    background: ${props =>
      props.backgroundColor ||
      (props.theme.colors || theme.colors).white} !important;
    border: 1px solid ${props => (props.theme.colors || theme.colors).iron} !important;
    height: 40px !important;
    width: inherit !important;
    min-width: ${props => props.minWidth || '146px'} !important;

    div {
      max-height: 40px !important;
    }

    hr {
      display: none !important;
    }

    button {
      height: 40px !important;
      /* NOTE: When I disable the filter select option I see a wierd drop down
         arrow icon, hiding this element makes it go away and doesn't seem
         to have any negative consequences. Will do this for now as part of
         PAD-2978, don't really understand what's changing but I do not want 
         to be spending time debugging material-ui when its an old version
         anyway. */
      display: none !important; /* Important is yuck */
    }

    div:nth-child(2) {
      div:nth-child(2) {
        height: 40px !important;
        line-height: 40px !important;
        top: 0 !important;
        font-size: ${props =>
          (props.theme.fontSizes || theme.fontSizes).materialUI
            .selectField} !important;
        padding-left: 15px !important;
        padding-right: 35px !important;
        color: ${props =>
          (props.theme.colors || theme.colors).secondary} !important;
        font-weight: initial !important;
        background-color: ${props => (props.disabled ? '#d9d9d9' : 'inherit')};
      }
    }
  }

  svg {
    position: absolute;
    width: 18px;
    height: 100%;
    right: 15px;
    z-index: ${props =>
      (props.theme.zIndexes || theme.zIndexes).mainContentWrapper.first};
    fill: ${props => (props.theme.colors || theme.colors).secondary};
    pointer-events: none;
  }
`
